import script from "./Category.vue?vue&type=script&setup=true&lang=js"
export * from "./Category.vue?vue&type=script&setup=true&lang=js"

import "./Category.vue?vue&type=style&index=0&id=c620ecee&lang=css"

const __exports__ = script;

export default __exports__